import { SuccessRO } from '@routellers/types/dist/shared/success.ro';
import { CreateTranslationDto } from '@routellers/types/dist/translation/create-translation.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = { data: CreateTranslationDto };

type ResponseData = SuccessRO;

export const createTranslation: ApiMethodDeclaration<ParamsData, ResponseData> = ({ data }) => ({
    url: '/translations',
    method: 'POST',
    data,
});
